import script from "./IndexIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexIndex.vue?vue&type=script&lang=ts&setup=true"

import "./IndexIndex.vue?vue&type=style&index=0&id=c5964512&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5964512"]])

export default __exports__